import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@mangosoft/mango-layout';
import { Subscription } from 'rxjs';

interface TranslateSubSidebar {
	search: string;
	back: string;
	add: string;
	next: string;
}
@Component({
	selector: 'app-sub-sidebar',
	templateUrl: './sub-sidebar.component.html',
	styleUrls: ['./sub-sidebar.component.scss'],
})
export class SubSidebarComponent implements OnInit, OnDestroy {
	@Input() back: boolean = false;
	@Input() next: boolean = false;
	@Input() add: boolean = false;
	@Input() tamHeightSibSidebar: number = 100;
	@Input() tamMinWidhtSibSidebar: number = 260;
	@Input() tamWidhtSibSidebar: number = 300;
	@Input() search: string = '';
	@Input() textTitle = '';
	@Output() searchText = new EventEmitter<string>();
	@Output() actionBack = new EventEmitter<boolean>();
	@Output() actionAdd = new EventEmitter<boolean>();
	@Output() actionNext = new EventEmitter<boolean>();
	@Output() scroll = new EventEmitter<boolean>();
	subscriptionTranslate!: Subscription;
	textSubSidebar: TranslateSubSidebar = {} as TranslateSubSidebar;
	selector = '.container';
	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.dataTranslate();
	}
	btnBack() {
		this.actionBack.emit(true);
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.textSubSidebar = data.components.subSidebar;
		});
	}

	btnaAdd() {
		this.actionAdd.emit(true);
	}
	btnNext() {
		this.actionNext.emit(true);
	}
	calcTamHeightSidebar(value: number) {
		let tam = 0;
		if (this.back || this.add || this.next) {
			tam = this.textTitle !== '' ? value + 80 : value + 30;
		} else {
			tam = value;
		}

		return {
			height: `calc(100vh - ${tam}px)`,
		};
	}

	calcWidthSidebar(value: number) {
		return {
			'min-width': `${value}px)`,
		};
	}

	emmitSearch(event: string) {
		this.searchText.emit(event);
	}
	onScroll() {
		this.scroll.emit(true);
	}
}
